
export const fetchAnnouncementaudioAudioStart = (audioRequest) => ({
    type: "FETCH_ANNOUNCEMENT_AUDIO_START",
    payload:audioRequest
  });
  
  export const fetchAnnouncementaudioAudioSuccess = (audioResponse) => ({
    type: "FETCH_ANNOUNCEMENT_AUDIO_SUCCESS",
    payload: audioResponse
  });
  
  export const fetchAnnouncementaudioAudioFailure = (error) => ({
    type: "FETCH_ANNOUNCEMENT_AUDIO_FAILURE",
    payload: error
  });
  